module.exports = __webpack_public_path__ + "static/img/11.46a0ed21.jpg";